import styled from 'styled-components';

const BlogTemplateStyle = styled.section`
	--gapRow: calc(var(--colPadding) * 2);
	--distanceHeader: var(--sp15x);
	--distancePagination: var(--sp9x);

	margin-top: var(--distanceHeader);

	.wrapper-items {
		.row {
			row-gap: var(--gapRow);
		}
	}

	.pagination-content {
		margin-top: var(--distancePagination);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceHeader: var(--sp13x);
		--distancePagination: var(--sp7x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceHeader: var(--sp12x);
		--distancePagination: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceHeader: var(--sp11x);
		--distancePagination: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceHeader: var(--sp9x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceHeader: var(--sp8x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceHeader: var(--sp7x);
		--gapRow: var(--sp2x);
	}
`;

export default BlogTemplateStyle;
